import "./App.css";
import { Routes, Route } from "react-router-dom"; // Import Routes, Route, and Navigate from 'react-router-dom'
import { Slide, ToastContainer } from "react-toastify";
import ShutDownPage from "./components/account/ShutDownPage";
import UserRoutes from "./UserRoutes";
import AdminRoutes from "./AdminRoutes";
import ResetPasswordPage from "./components/account/ResetPassword";
import ForgotPasswordPage from "./components/account/ForgotPassword";
import NotFoundPage from "./components/NotFoundPage";

function App() {
  // const location = useLocation();
  // const { pathname } = location;
  console.log("Current version : 0.1");

  return (
    <>
      <Routes>
        {/* User routes */}
        {UserRoutes()}

        {/* Admin routes */}
        {AdminRoutes()}
        <Route path="/shut-down" element={<ShutDownPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
    </>
  );
}

export default App;
